/** @module csi/table/TablePlaceholder */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"csi/html",
	"csi/locale",
	"csi/widget/ActionsComboButton",
	"csi/widget/Automation",
	"dojo/text!csi/templates/tablePlaceholder.html"
], function(declare, lang, _, _TemplatedMixin, _WidgetBase, html, locale, ActionsComboButton, Automation, template) {

	const SUSPEND = "Suspend";

	return declare([_WidgetBase, _TemplatedMixin], {
		templateString: template,

		/** @property {boolean} bImage - indicate placeholders image should display or not */
		bImage: false,

		/** @property {number} columns - for column span */
		columns: null,

		/** @property {string} description - placeholder description */
		description: "",

		/** @property {boolean} showActions - indicate whether placeholder should show actions or not */
		showActions: true,

		/** @property {string} titleText -  placeholder title */
		titleText: "",

		/** @property {string} type - indicate whether placeholder is NoResult or Suspend */
		type: null,

		/** @property {ViewWidget} widget */
		widget: null,

		/**
		 * Create ActionsComboButton for provided list of actions
		 * @param {Action} defAction - button default action, must be provided
		 * @param {Action[]} actions - required element, might be empty array
		 * @param {Action[]} placeholderActions - current view' placeholder actions
		 * @param {DOMNode} domNode - dom node where button will be inserted
		 * @param {View} widget
		 * @param {string} createButtonResource - resource to use for action menu (rather than use first action)
		 */
		createActionsButton: function(defAction, actions, placeholderActions, domNode, widget, createButtonResource) {
			const {defView, newActionsButtonGroups} = widget;
			const bCreateButton = placeholderActions?.length > 0 || createButtonResource;
			const cssClass = this._getPlaceholderCss(bCreateButton) + " csi-actions-new";
			const key = defView.getHtmlKey();
			const createBtnId = "ActionsNew" + (createButtonResource || "");
			const qrRoot = widget.getQueryResult();
			const ctx = qrRoot?.getChildContext();

			new ActionsComboButton(Automation.params(key, "placeholder", createBtnId, {
				"class": cssClass,
				disabled: (ctx && defAction) ? !defAction.hasAccess(ctx) : false,
				materialIcon: 'add',
				bCreateButton,
				label: bCreateButton ? locale.resource(createButtonResource) : defAction.getName(),
				actions,
				placeholderActions,
				newActionsButtonGroups,
				widget,

				onAction: (action) => {
					widget._onElementAction(domNode, action);
				},

				onClick: (e) => {
					widget._onElementActionClick(domNode, defAction, e);
				}
			})).placeAt(html.create("div", {"class": "csi-placeholder-actions"}, domNode));
		},

		postCreate: function() {
			// show image
			if (this.bImage) {
				html.setVisible(this.imageBoxNode, true);
				this.domNode.classList.add("csi-table-placeholder-with-image");
			}

			if (this.showActions) {
				// Add Actions Combo Button
				var w = this.widget;
				var qrRoot = w.getQueryResult();
				var ctx = qrRoot.getChildContext();

				var actions = qrRoot.getNewActions(ctx, false);
				var bActions = actions && actions.length;

				const filteredPlaceholderActions = w.getFilteredPlaceholderActions();
				const bPlaceholderActions = !!filteredPlaceholderActions.length;
				if (bActions || bPlaceholderActions) {
					var node = this.rootActionsNode;
					w.setQueryResultActionContext(qrRoot, ctx, node);
					html.setDataAttribute(node, "ButtonNewActions", true);

					if (bActions && (bPlaceholderActions || w.newActionsButtonResource)) {
						this.createActionsButton(null, actions, filteredPlaceholderActions, node, w, w.newActionsButtonResource || "Create");
					} else {
						if (bPlaceholderActions) {
							actions = filteredPlaceholderActions;
						}
						this.createActionsButton(actions.shift(), actions, null, node, w);
					}
				}
			}
		},

		/**
		 * Return button class to use for placeholder action
		 * @param {boolean} bCreateButton
		 * @return {string}
		 */
		_getPlaceholderCss: function(bCreateButton) {
			return bCreateButton ? "csi-secondary-btn" : "csi-secondary-cmb-btn";
		}
	});
});